import { Navigate, Outlet } from "react-router";
import _ from "lodash";

import { URLS } from "config/urls";

import { useSignedUser } from "entities/Auth/sdk";

const PayingCustomerGuard = () => {
  const { data: user } = useSignedUser();

  if (!_.isNil(user) && !user.company_is_paying_customer) {
    return <Navigate to={URLS.NOT_FOUND} />;
  }

  return <Outlet />;
};

export default PayingCustomerGuard;
